module.exports = __webpack_public_path__ + "img/blank-comic-book_B0997SYSM9.23f0a11f.jpg";